<template>
  <div class="video-show"  ref="activity_scroll" @scroll="activityScroll">
    <div class="menu-main">
        <ul class="menu">
            <li @click="handleMenu('1')" :class="menuType == '1'? 'active': ''">离心机视频一览</li>
            <li @click="handleMenu('2')" :class="menuType == '2'? 'active': ''">选型工具</li>
        </ul>
    </div>
    <p class="menu-tip" v-show="menuType == '1'">查看视频了解Eppendorf 经典离心机；</p>
    <p class="menu-tip" v-show="menuType == '1'">更多产品详情，请点击【选型工具】，获取属于您的离心机及套装。</p>
    <!-- <div v-show="menuType == '1'" class="pro-main">
        <ul class="model-pro">
            <li @click="handleAll(0)" :class="selIndex == -1 ? 'liActive': ''">
                <span class="one" >全部</span>
            </li>
            <li v-for="(item,index) in cateList" :key="item.id" @click="handleCate(item.children,index)" :class="selIndex == index ? 'liActive': ''">
                <span class="one">{{ item.title }}</span>
                <span class="iconfont icon-zhankai-01 class-icon-col poly-class-icon"></span>
            </li>
        </ul>
        
    </div> -->
    <!--   -->
    <div >
        <newProVideo v-show="menuType == '1'" :productVideo="productVideo" @videoChange="videoChange"></newProVideo>
    </div>
    
    <!-- 视频播放 -->
    <video-play ref="videoPlay"></video-play>
    
    <div v-show="menuType == '2'">
        <ul class="modele-con">
            <li v-for="(item,index) in list" :key="index" @click="handleDetail(item.url)">
                <img class="img-icon" :src="cdnUrl + item.img" alt="">
                <!-- <img class="img-right" :src="cdnUrl + 'Firnx88-us9t8CZl1ck92FFR98eZ'" alt=""> -->
                <div>
                    <p class="model-tip">{{ item.title }}</p>
                    <p style="color:#666666;">{{ item.content }}</p>
                </div>
            </li>
        </ul>
    </div>
    <footerLine></footerLine>
    <van-popup
      v-model="showBottomPosition"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <van-picker :columns="columns" value-key="title" title="" show-toolbar
        @cancel="showBottomPosition = false" @confirm="onConfirm"/>
    </van-popup>
  </div>
</template>

<script>
import { getProCate,getProBindList } from '@/api/centrifuge'
import newProVideo from './components/new-pro-video.vue'
// import { setPurchaseNum } from '@/api/sucker'
import { centrifugeRecord } from '@/libs/common'
import videoPlay from '@/components/videoPlay'
import footerLine from '@/components/footerLine'
import DPlayer from 'dplayer'

export default {
    components: {
        newProVideo,
        videoPlay,
        footerLine
    },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            menuType: '1',
            detail: '',
            cateList: [], // 类别列表
            showBottomPosition: false, // 类别二级
            columns: [], // 二级列表
            page: 1,
            cid: 0,
            productVideo: [], // 绑定列表
            list: [
                // '/eppendorf_single/index.html?from=singlemessage&isappinstalled=0#/?category_id=106'
                {img: 'FvUFllpT09p-vul3Q_dYFZ7p6CUQ',title: '根据管型筛选',content: '离心管型/数量/离心力',url: 'filterProduct' },
                // '/eppendorf_single/index.html?from=singlemessage&isappinstalled=0#/centrifuge?type=2'
                {img: 'FoTutFQ4e-58Lbowvlu6qU4idd5w',title: '根据应用筛选',content: '核酸/蛋白/细胞等离心场景',url: 'centrifuge' },
                {img: 'FvX15b5FJ_eBb1Cic4GpZAcF2IoJ',title: '落地高速/超速离心机',content: '离心力/样品体积',url: 'https://www.eppendorf.com/cn-zh/centrifuge-assistant/'},
            ],
            showVideo: false,
            selIndex: -1, // 筛选分类时(分类的下标)
        }
    },
    created() {
        this.getCateList()
        this.getProList()
    },
    methods: {
        videoChange (item) {
            var videoUrl = JSON.parse(item.video_url)
            this.videoUrl = videoUrl[0]
            this.$refs.videoPlay.dplayerOption(`${this.cdnUrl + this.videoUrl}`)
        },
        getCateList() { // 类别
            getProCate({type:6}).then(res => {
                this.cateList = res
            })
        },
        getProList() {
            let para = {
                module: '1',
                type: '1',
                page: this.page,
                cid: this.cid || 0
            }
            getProBindList(para).then(res => {
                // console.log('绑定列表',res);
                this.$toast.clear()
                this.productVideo.push(...res.data.data)
                this.last_page = res.data.last_page
            })
        },
        activityScroll () {
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 5 // 距离底部距离
            this.scrollTop = scrollTop
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    this.getProList()
                }
            }
        },
        handleCate(item,index) { // 类别筛选
            this.columns = item
            this.showBottomPosition = true
            this.selIndex = index
            this.getCateList()
        },
        handleAll() {
            this.cid = 0
            this.selIndex = -1
            this.page = 1
            this.productVideo = []
            this.getProList()
            this.getCateList()
        },
        onConfirm(item) {
            // console.log('类别筛选确定',item);
            this.cateList[this.selIndex].title = item.title
            let para = {
                type: 6, // 6 离心机产品特性
                type_id: item.id,
                uid: this.$store.state.user.id || 53,
                action: 1
            }
            centrifugeRecord(para) // 人数，次数记录
            this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            })
            this.cid = item.id
            this.page = 1
            this.productVideo = []
            this.getProList()
            this.showBottomPosition = false
        },
        handleMenu(type) {
            this.menuType = type
            this.productVideo = []
            let para = {
                type: type == '1'?13:14, // 13 产品特性 14 选型工具
                uid: this.$store.state.user.id || 0,
                action: 1,
                type_id: 0
            }
            centrifugeRecord(para) // 人数，次数记录
            this.getProList()
        },
        handleDetail(url) {
            if(!url) {
                this.$toast('敬请期待')
                return
            }
            if(url.indexOf('https') != -1) {
                window.location.href = url
            } else {
                let para = {}
                url == 'filterProduct' ? para.category_id = '106' : para.type = '2'
                this.$router.push({
                    name: url,
                    query: para
                })
            }
            
            // window.location.href = url
        },

    }
}
</script>

<style lang="scss" scoped>
.video-show {
    height: 100vh;
    overflow: auto;
}
.menu-main {
    display: flex;
    justify-content: center;
    margin-top: rem(20);
    .menu {
        width: rem(343);
        height: rem(30);
        display: flex;
        justify-content: center;
        // align-items: center;
        border-radius: 4px;
        color: #6CC5DB;
        border: 1px solid #6C94DB;
        li {
            flex: 1;
            line-height: rem(30);
            text-align: center;
        }
        .active {
            color: #fff;
            background-color: #6CC5DB;
            border-radius: 4px;
        }
    }
}
.menu-tip {
    width: rem(343);
    margin: 0 auto;
    margin-top: rem(12);
    margin-bottom: rem(12);
    font-size: rem(12);
    // background-color: #6CC5DB;
}
.pro-main {
    display: flex;
    justify-content: center;
    margin-bottom: rem(16);
    .model-pro {
        display: flex;
        justify-content: space-between;
        width: rem(343);
        margin-top: rem(12);
    li {
        display: flex;
        justify-content: space-around;
        width: rem(109);
        height: rem(30);
        line-height: rem(30);
        text-align: center;
        color: #6CC5DB;
        background-color: #fff;
        box-shadow: 0px 1px 4px 0px rgba(51,51,51,0.5);
        border-radius: 4px;
        border: 1px solid #6C94DB;
        // background: linear-gradient(135deg, #F6FCFF 0%, #EEF9FF 100%);
    }
    .liActive {
        color: #fff;
        background: #6CC5DB;
    }
    .class-icon-col {
        color: $poly-color;
        // transform: rotate(180deg);
    }
    .poly-class-icon {
        text-align: right;
        transform: rotatex(180deg);
        span {
            font-size: rem(12);
        }
    }
}
}

.modele-con {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    li {
        display: flex;
        // justify-content: space-between;
        align-items: center;
        position: relative;
        width: rem(343);
        height: rem(105);
        margin-top: rem(20);
        // padding: 0 rem(96) 0 rem(64);
        background: #F8FEFF;
        border-radius: rem(6);
        box-shadow: 0px 2px 6px 0px rgba(102,102,102,0.5);
        box-sizing: border-box;
    }
    li:nth-child(3) {
        .img-icon {
            margin-right: rem(25);
        }
    }
    .model-tip {
        font-size: 21px;
        font-weight: bold;
        margin-bottom: rem(2);
        color: #333333db;
    }
    .img-icon {
        width: rem(58);
        height: rem(58);
        margin-left: rem(64);
        margin-right: rem(37);
    }
    
    .img-right {
        position: absolute;
        top: 0;
        right: 0;
    }
}
.van-overlayes{
    z-index: 9999;
    .dplayer-containers{
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      margin: 0 auto;
      .video-container{
        width: 100%;
        height: 280px;
      }
    }
}
.video-play{
position: absolute;
top: 45%;
left: 50%;
transform: translate(-50%, -50%);
width: 90%;
z-index: 999;
video{
    height: rem(220);
}
}
</style>